import { render } from "./TextLImageR.vue?vue&type=template&id=57290bd4"
import script from "./TextLImageR.vue?vue&type=script&lang=js"
export * from "./TextLImageR.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__